import React from 'react';
import arrowWhite from '../../images/icons/arrow-white.svg';
import { navigate } from 'gatsby';
import useTranslations from '../../utils/useTranslations';

const HelpCenterBlog = (props) => {
    const t = useTranslations(props.text);

    function buttonClicked() {
        navigate('/blog');
    }

    return (
        <div className="help-center-blog p-4 mb-5 ml-auto">
            <button className="btn-no-styling text-left" onClick={() => buttonClicked()}>
                <div className="text">{t('blogInfo')}</div>
                <div className="tw-mt-4 tw-flex tw-items-center tw-gap-1 tw-text-xl tw-font-bold">
                    {t('visitBlog')} <img src={arrowWhite} alt={t('visitBlog')} />
                </div>
            </button>
        </div>
    );
};

export default HelpCenterBlog;
